// Vee Validation.
import { configure } from 'vee-validate'
import { extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import veeLang from 'vee-validate/dist/locale/en.json'
//import { messages } from 'vee-validate/dist/locale/en.json'

// Element UI.
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

export default {
    install(Vue) {

        // Vee Validation.
        configure({
            classes: {
                valid: 'is-valid',
                invalid: 'is-invalid',
                dirty: ['is-dirty', 'is-dirty'], // multiple classes per flag!
            }
        })
        Object.keys(rules).forEach(rule => {
            extend(rule, {
                ...rules[rule], // copies rule configuration
                message: veeLang.messages[rule] // assign message
            });
        });
                  
        // Element UI.
        locale.use(lang)
    }
}
  